export default __webpack_public_path__ + "static/Icon-Capilar-67b09c1c597a6bf1a73ddaa2050f236a.svg";